import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_PRIVATE_MESSAGE_REPLY,
  GET_PRIVATE_MESSAGE_REPLIES,
  GET_PRIVATE_MESSAGE_REPLIES_BY_FILTER,
  ADD_PRIVATE_MESSAGE_REPLY,
  UPDATE_PRIVATE_MESSAGE_REPLY,
  UPDATE_PRIVATE_MESSAGE_REPLY_ALREADY_READ,
  DELETE_PRIVATE_MESSAGE_REPLY,
} from '../../../../queries/modules/pm/private-message-reply';

export async function getPrivateMessageReplies(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGE_REPLIES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setPrivateMessageReplies', data.getPrivateMessageReplyReplies);
      context.commit('setSuccess', null);
      return data.getPrivateMessageReplyReplies
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getPrivateMessageReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGE_REPLY,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getPrivateMessageReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getPrivateMessageRepliesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_PRIVATE_MESSAGE_REPLIES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setPrivateMessageReplies', data.getPrivateMessageRepliesByFilter);
      context.commit('setSuccess', null);
      return data.getPrivateMessageRepliesByFilter
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addPrivateMessageReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_PRIVATE_MESSAGE_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const webBoardReplies = [...context.state.webBoardReplies];
      // webBoardReplies.unshift(data.addPrivateMessageReply);
      // context.commit('setPrivateMessageReplies', webBoardReplies);
      context.commit('setSuccess', newItemSuccess(data.addPrivateMessageReply.message));

      return data.addPrivateMessageReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updatePrivateMessageReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PRIVATE_MESSAGE_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.webBoardReplies.findIndex(item => item.id === data.updatePrivateMessageReply.id);
      const webBoardReplies = [
        ...context.state.webBoardReplies.slice(0, index),
        data.updatePrivateMessageReply,
        ...context.state.webBoardReplies.slice(index + 1)
      ];
      context.commit('setPrivateMessageReplies', webBoardReplies);
      context.commit('setSuccess', updateItemSuccess(data.updatePrivateMessageReply.message));

      return data.updatePrivateMessageReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updatePrivateMessageReplyAlreadyRead(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_PRIVATE_MESSAGE_REPLY_ALREADY_READ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      // const index = context.state.webBoardReplies.findIndex(item => item.id === data.updatePrivateMessageReplyAlreadyRead.id);
      // const webBoardReplies = [
      //   ...context.state.webBoardReplies.slice(0, index),
      //   data.updatePrivateMessageReplyAlreadyRead,
      //   ...context.state.webBoardReplies.slice(index + 1)
      // ];
      // context.commit('setPrivateMessageReplies', webBoardReplies);
      context.commit('setSuccess', updateItemSuccess(data.updatePrivateMessageReplyAlreadyRead.message));

      return data.updatePrivateMessageReplyAlreadyRead
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deletePrivateMessageReply(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_PRIVATE_MESSAGE_REPLY,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const index = context.state.webBoardReplies.findIndex(item => item.id === data.deletePrivateMessageReply.id);
      // const webBoardReplies = [
      //   ...context.state.webBoardReplies.slice(0, index),
      //   ...context.state.webBoardReplies.slice(index + 1)
      // ];
      // context.commit('setPrivateMessageReplies', webBoardReplies);
      context.commit('setSuccess', deleteItemSuccess(data.deletePrivateMessageReply.message));

      return data.deletePrivateMessageReply
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

